import { derived } from 'svelte/store';
import { Role } from '../types';
import { getAssignedActiveConversations } from './util';
import { NewItemsStore } from '../common/new-items-store';
export class ConversationStartedNotifier {
    constructor(mySession, conversations, soundPlayer) {
        this.mySession = mySession;
        this.conversations = conversations;
        this.soundPlayer = soundPlayer;
        const myAsClientActiveConversations = derived([mySession, conversations], ([_mySession, _conversations]) => {
            if (_mySession == null || !_mySession.roles.includes(Role.CLIENT)) {
                return [];
            }
            return getAssignedActiveConversations(_mySession, _conversations);
        });
        this.myAsClientNewActiveConversations = new NewItemsStore(myAsClientActiveConversations, () => soundPlayer.playNewConversationNotificationLoop(), () => soundPlayer.stopNewConversationNotificationLoop());
        this.shouldNotifyStore = derived(this.myAsClientNewActiveConversations, $ => $.size > 0);
        this.subscribe = this.shouldNotifyStore.subscribe;
    }
    snoozeAll() {
        this.myAsClientNewActiveConversations.snoozeAll();
    }
}
